/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FilterSovQueryDto,
  GetSovSummaryQueryDto,
  ScheduleOfValuesPaginationResponseDto,
  SovSummaryResponseDto,
  UpdateScheduleOfValuesPayloadDto,
  UpsertScheduleOfValuesPayloadDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterSovQueryDtoFromJSON,
    FilterSovQueryDtoToJSON,
    GetSovSummaryQueryDtoFromJSON,
    GetSovSummaryQueryDtoToJSON,
    ScheduleOfValuesPaginationResponseDtoFromJSON,
    ScheduleOfValuesPaginationResponseDtoToJSON,
    SovSummaryResponseDtoFromJSON,
    SovSummaryResponseDtoToJSON,
    UpdateScheduleOfValuesPayloadDtoFromJSON,
    UpdateScheduleOfValuesPayloadDtoToJSON,
    UpsertScheduleOfValuesPayloadDtoFromJSON,
    UpsertScheduleOfValuesPayloadDtoToJSON,
} from '../models/index';

export interface DeleteScheduleOfValuesRequest {
    sovId: string;
}

export interface FilterSovRequest {
    filterSovQueryDto: FilterSovQueryDto;
    page?: number;
    pageSize?: number;
}

export interface GetSovCountryListRequest {
    submissionId: string;
}

export interface GetSovOccupancyListRequest {
    submissionId: string;
}

export interface GetSovSummaryRequest {
    getSovSummaryQueryDto: GetSovSummaryQueryDto;
}

export interface ProcessSovFileRequest {
    fileId: string;
}

export interface UpdateScheduleOfValuesRequest {
    updateScheduleOfValuesPayloadDto: Array<UpdateScheduleOfValuesPayloadDto>;
}

export interface UpsertScheduleOfValuesRequest {
    upsertScheduleOfValuesPayloadDto: Array<UpsertScheduleOfValuesPayloadDto>;
}

/**
 * 
 */
export class ScheduleOfValuesApi extends runtime.BaseAPI {

    /**
     * Delete SOV by file id
     */
    async deleteScheduleOfValuesRaw(requestParameters: DeleteScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sovId'] == null) {
            throw new runtime.RequiredError(
                'sovId',
                'Required parameter "sovId" was null or undefined when calling deleteScheduleOfValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/delete/{sovId}`.replace(`{${"sovId"}}`, encodeURIComponent(String(requestParameters['sovId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete SOV by file id
     */
    async deleteScheduleOfValues(requestParameters: DeleteScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScheduleOfValuesRaw(requestParameters, initOverrides);
    }

    /**
     * Filter SOV
     */
    async filterSovRaw(requestParameters: FilterSovRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduleOfValuesPaginationResponseDto>> {
        if (requestParameters['filterSovQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterSovQueryDto',
                'Required parameter "filterSovQueryDto" was null or undefined when calling filterSov().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterSovQueryDtoToJSON(requestParameters['filterSovQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduleOfValuesPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter SOV
     */
    async filterSov(requestParameters: FilterSovRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduleOfValuesPaginationResponseDto> {
        const response = await this.filterSovRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SOV country list
     */
    async getSovCountryListRaw(requestParameters: GetSovCountryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getSovCountryList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['submissionId'] != null) {
            queryParameters['submissionId'] = requestParameters['submissionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/country-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get SOV country list
     */
    async getSovCountryList(requestParameters: GetSovCountryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSovCountryListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SOV occupancy list
     */
    async getSovOccupancyListRaw(requestParameters: GetSovOccupancyListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getSovOccupancyList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['submissionId'] != null) {
            queryParameters['submissionId'] = requestParameters['submissionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/occupancy-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get SOV occupancy list
     */
    async getSovOccupancyList(requestParameters: GetSovOccupancyListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSovOccupancyListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Schedule of Values summary
     */
    async getSovSummaryRaw(requestParameters: GetSovSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SovSummaryResponseDto>> {
        if (requestParameters['getSovSummaryQueryDto'] == null) {
            throw new runtime.RequiredError(
                'getSovSummaryQueryDto',
                'Required parameter "getSovSummaryQueryDto" was null or undefined when calling getSovSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSovSummaryQueryDtoToJSON(requestParameters['getSovSummaryQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SovSummaryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Schedule of Values summary
     */
    async getSovSummary(requestParameters: GetSovSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SovSummaryResponseDto> {
        const response = await this.getSovSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process SOV file
     */
    async processSovFileRaw(requestParameters: ProcessSovFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling processSovFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/process/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters['fileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process SOV file
     */
    async processSovFile(requestParameters: ProcessSovFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processSovFileRaw(requestParameters, initOverrides);
    }

    /**
     * Update SOV
     */
    async updateScheduleOfValuesRaw(requestParameters: UpdateScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateScheduleOfValuesPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateScheduleOfValuesPayloadDto',
                'Required parameter "updateScheduleOfValuesPayloadDto" was null or undefined when calling updateScheduleOfValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values/update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateScheduleOfValuesPayloadDto']!.map(UpdateScheduleOfValuesPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update SOV
     */
    async updateScheduleOfValues(requestParameters: UpdateScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScheduleOfValuesRaw(requestParameters, initOverrides);
    }

    /**
     * Upsert SOV
     */
    async upsertScheduleOfValuesRaw(requestParameters: UpsertScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['upsertScheduleOfValuesPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'upsertScheduleOfValuesPayloadDto',
                'Required parameter "upsertScheduleOfValuesPayloadDto" was null or undefined when calling upsertScheduleOfValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/schedule-of-values`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['upsertScheduleOfValuesPayloadDto']!.map(UpsertScheduleOfValuesPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upsert SOV
     */
    async upsertScheduleOfValues(requestParameters: UpsertScheduleOfValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertScheduleOfValuesRaw(requestParameters, initOverrides);
    }

}
